import { createStandardAction } from 'typesafe-actions';

export const setSelectedClass = createStandardAction(
  'CLASSDIGITALNOTEBOOK/SET_SELECTED_CLASS'
)<{ selectedClass: string }>();

export const setSelectedLessons = createStandardAction(
  'CLASSDIGITALNOTEBOOK/SET_SELECTED_LESSONS'
)<{ selectedLesson: string }>();

